import * as React from "react";
const VisibilityContext = React.createContext({
  isVisible: true
});
const VisibilityProvider = ({ isVisible, children }) => {
  return /* @__PURE__ */ React.createElement(VisibilityContext.Provider, { value: React.useMemo(() => ({ isVisible }), [isVisible]) }, children);
};
export {
  VisibilityContext,
  VisibilityProvider
};
